import { serverCall } from 'utils/serverCall';
import {
  initOilListRequest,
  setOilList,
  errorOilList,
  addOil,
  updateOil,
  initOilRequest,
  setOil,
  errorOilRequest,
  deleteOil
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchOilList = ({
  searchQuery=null, selectedOil=null, currentPage=null, rowsPerPage=null
} = {}) => {
  return async (dispatch) => {
    dispatch(initOilListRequest());
    // Construct query parameters based on provided values
    const params = new URLSearchParams();
    if (searchQuery !== null) params.append('brand_name', searchQuery);
    if (selectedOil !== null) params.append('oil_type', selectedOil);
    if (currentPage !== null) params.append('page', currentPage);
    if (rowsPerPage !== null) params.append('limit', rowsPerPage);
    

    try {
      const result = await serverCall(`${apiEndpoints.GET_ALL_OIL}/?${params.toString()}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setOilList(result?.data?.payload));
      } else {
        dispatch(errorOilList(result.message));
      }
    } catch (error) {
      dispatch(errorOilList(error.message));
    }
  };
};

export const createOil = (oilData, toggleModal) => {
  return async (dispatch) => {
    dispatch(initOilListRequest());
    
    try {
      const result = await serverCall(apiEndpoints.OIL_CREATE, 'POST', dispatch, oilData);
      if (result.success) {
        dispatch(fetchOilList({ currentPage:1, rowsPerPage:10 }))
        dispatch(addOil());
        
        toggleModal()
        toast.success('Oil created successfully');
        // return Promise.resolve();
      } else {
        toast.error(result.message);
        dispatch(errorOilRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorOilRequest(error.message));
      // return Promise.reject(error);
    }
  };
};


export const fetchOilById = (oilId, stateToManage) => {
  return async (dispatch) => {
    dispatch(initOilRequest());

    try {
      const result = await serverCall(`${apiEndpoints.OIL_BYID}${oilId}`, 'GET', dispatch);

      if (result.success) {
        dispatch(setOil(result?.data?.payload?.oilDataWithSerialNumber[0]));
        stateToManage((prevState) => !prevState)
      } else {
        dispatch(errorOilRequest(result.message));
      }
    } catch (error) {
      dispatch(errorOilRequest(error.message));
    }
  };
};

export const updateOilById = (oilData, toggleModal, searchQuery, selectedOil) => {
  return async (dispatch) => {
    dispatch(initOilListRequest());
    try {
      const result = await serverCall(apiEndpoints.OIL_UPDATE, 'POST', dispatch, oilData);
      if (result.success) {
        dispatch(updateOil(oilData));
        dispatch(fetchOilList({searchQuery, selectedOil, currentPage:1, rowsPerPage:10}))
        toggleModal()
        toast.success('Oil updated successfully');
        // return Promise.resolve();
      } else {
        toast.error(result.message);
        dispatch(errorOilRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorOilRequest(error.message));
      // return Promise.reject(error);
    }
  };
};

export const deleteOilById = (payload,toggleModal) => {
  return async (dispatch) => {
    dispatch(initOilListRequest());
    try {
      const {id:oilId, currentPage, rowsPerPage, selectedOil} = payload 
      const result = await serverCall(`${apiEndpoints.OIL_DELETE}/${oilId}`, 'DELETE', dispatch);
      
      if (result.success) {
        dispatch(deleteOil(oilId));
        dispatch(fetchOilList({ searchQuery: '', selectedOil: selectedOil === 'ot' ? null : selectedOil, currentPage, rowsPerPage })) 
        toast.success(result.message || 'Oil deleted successfully');
        toggleModal()
      } else {
        toast.error(result.message);
        dispatch(errorOilRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorOilRequest(error.message)); 
    }
  };
};